import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed";
import type { AccessibleChannel, ServerInfo } from '../../types';
import { FlatList, Image } from 'react-native';
import { Checkbox, SearchBox } from '../../Components';
import { useColors } from '../../constants/useColors';

type ServerInfoProps = {
    server:ServerInfo
    selected_channels: string[],
    onClose:() => void,
    onSelectChannel: (channel_id:string) => void,
    onDeselectChannel: (channel_id:string) => void 
}
const ServerInfoCard = ({ server, selected_channels, onDeselectChannel, onSelectChannel, onClose }:ServerInfoProps) => {
    const Colors = useColors();
    const [ channel_search, setChannelSearch ] = useState('');
    const filtered_channels = server.accessibleChannels.filter(c => `${c.name}`.toLowerCase().includes(channel_search));

    const renderChannels = (data: { item: AccessibleChannel, index:number }) => {
        const selected = selected_channels.includes(data.item.id) ? true : false
        return (
             <View transparent type='row' style={{ padding:8, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <Checkbox
                    style={{ marginRight:10 }}
                    checked={selected}
                    onSelect={() => selected ? onDeselectChannel(data.item.id) : onSelectChannel(data.item.id)}
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.name}</Text>
                </View>
            </View>
        )
    }

    return (
        <View float style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
              <Image
                source={{ uri: server.icon ?? '' }}
                style={{ height:40, width:40 }}
              />
              <View transparent style={{ flex:1, marginLeft:10 }}>
                <Text theme='h1'>{server.name}</Text>
                <Text theme='description' style={{ marginTop:3 }}>{server.description}</Text>
              </View>
            </View>
            <View style={{ flex:1, padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Select Channels Below</Text>
                <View transparent style={{ padding:5 }}>
                    <SearchBox onChange={(text) => setChannelSearch(text)} hide_search_button/>
                </View>
                <FlatList
                    key={'channel_list'}
                    data={filtered_channels.sort((a,b) => a.name.localeCompare(b.name))}
                    renderItem={renderChannels}
                    keyExtractor={(item) => item.id}
                />
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
              <Button
                type='close'
                title='CLOSE'
                style={{ flex:1 }}
                onPress={() => onClose()}
              />
            </View>
        </View>
    )

}

export default ServerInfoCard